import * as localForage from "localforage";
import storageFallback from "./storageFallback";

const Queue = new Map();

export const getItem = (key: string) =>
  new Promise(resolve => {
    const existingPromise = Queue.get(key);

    if (existingPromise) {
      existingPromise.then((data: any) => resolve([data, null]));
    } else {
      localForage.getItem(key);
    }

    const save = (data: any) => localForage.setItem(key, data);

    localForage
      .getItem(key)
      .catch(() => resolve([null, save]))
      .then(data => resolve([data, save]));
  });

export const initStore = () => {
  storageFallback();

  localForage.config({
    description: "Used for caching requests",
    driver: [localForage.INDEXEDDB, localForage.LOCALSTORAGE],
    name: "feedback",
    storeName: "cache",
    version: 0.1
  });

  return localForage.clear();
};
